export const UPDATE_SPECIALIST_STATUS = "UPDATE_SPECIALIST_STATUS"
export const RETRIEVE_BLOG_CATEGORY = "RETRIEVE_BLOG_CATEGORY"
export const CREATE_FORUM_CATEGORY = "CREATE_FORUM_CATEGORY"
export const DELETE_FORUM_CATEGORY = "DELETE_FORUM_CATEGORY"
export const UPDATE_FORUM_CATEGORY = "UPDATE_FORUM_CATEGORY"
export const UPDATE_WEBINAR_STATUS = "UPDATE_WEBINAR_STATUS"
export const CREATE_BLOG_CATEGORY = "CREATE_BLOG_CATEGORY"
export const UPDATE_BLOG_CATEGORY = "UPDATE_BLOG_CATEGORY"
export const DELETE_BLOG_CATEGORY = "DELETE_BLOG_CATEGORY"
export const UPDATE_MEMBER_STATUS = "UPDATE_MEMBER_STATUS"
export const DISABLE_USER_STATUS = "DISABLE_USER_STATUS"
export const UPDTAE_FORUM_STATUS = "UPDTAE_FORUM_STATUS"
export const UPDTAE_BLOG_STATUS = "UPDTAE_BLOG_STATUS"
export const VERIFY_SPECIALIST = "VERIFY_SPECIALIST"
export const REJECT_SPECIALIST = "REJECT_SPECIALIST"
export const DELETE_SPECIALIST = "DELETE_SPECIALIST"
export const ASK_VERIFICATION = "ASK_VERIFICATION"
export const DELETE_WEBINAR = "DELETE_WEBINAR"
export const UPDATE_WEBINAR = "UPDATE_WEBINAR"
export const DELETE_MEMBER = "DELETE_MEMBER"
export const DELETE_FORUM = "DELETE_FORUM"
export const DELETE_BLOG = "DELETE_BLOG"
export const DELETE_FAQ = "DELETE_FAQ"
export const SEND_MAIL = "SEND_MAIL"

const ACTIONS = {
  UPDATE_SPECIALIST_STATUS,
  RETRIEVE_BLOG_CATEGORY,
  CREATE_FORUM_CATEGORY,
  DELETE_FORUM_CATEGORY,
  UPDATE_FORUM_CATEGORY,
  UPDATE_WEBINAR_STATUS,
  CREATE_BLOG_CATEGORY,
  UPDATE_BLOG_CATEGORY,
  DELETE_BLOG_CATEGORY,
  UPDATE_MEMBER_STATUS,
  DISABLE_USER_STATUS,
  UPDTAE_FORUM_STATUS,
  UPDTAE_BLOG_STATUS,
  VERIFY_SPECIALIST,
  REJECT_SPECIALIST,
  DELETE_SPECIALIST,
  ASK_VERIFICATION,
  DELETE_WEBINAR,
  UPDATE_WEBINAR,
  DELETE_MEMBER,
  DELETE_FORUM,
  DELETE_BLOG,
  DELETE_FAQ,
  SEND_MAIL,
}

export default ACTIONS